import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/pages/home'
import Index from '@/pages/Index'

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true },
    },
    {
      path: '/metafields',
      name: 'Metafields',
      component: () => import('@/pages/metafields.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/product-import',
      name: 'ProductImport',
      component: () => import('@/pages/product-import.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/export',
      name: 'Export',
      component: () => import('@/pages/export.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/logs',
      name: 'Logs',
      component: () => import('@/pages/logs.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: () => import('@/pages/pricing.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/payment',
      name: 'Payment',
      component: () => import('@/pages/payment.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/not-authorized',
      name: 'NotAuthorized',
      component: () => import('@/pages/not-authorized/index.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js